import * as z from 'zod';
import { dateTimeSchema, emailForwardParseMethodSchema } from '../../enums.mjs';
import { fileId, emailSubmissionId } from '../../types/opaque.mjs';

const originalMessageSchema = z.object({
    senderEmail: z.string().toLowerCase(),
    senderName: z.string(),
    subject: z.string(),
    sentAt: dateTimeSchema.nullable(),
    to: z.string(),
    cc: z.string(),
    bodyText: z.string(),
});
const attachmentMetadataSchema = z.object({
    filename: z.string().min(1),
    mimeType: z.string().min(1),
    sizeBytes: z.number().int().nonnegative(),
});
const attachmentFileReferenceSchema = z.object({
    fileId,
});
var Submission;
(function (Submission) {
    (function (Request) {
        Request.schema = z.object({
            gmailMessageId: z.string().min(1),
            gmailThreadId: z.string().min(1),
            receivedAt: dateTimeSchema,
            subject: z.string(),
            forwardedByEmail: z.string(),
            forwardedByName: z.string().nullable(),
            bodyText: z.string(),
            bodyHtml: z.string(),
            coverNote: z.string().nullable(),
            parseMethod: emailForwardParseMethodSchema,
            original: originalMessageSchema.nullable(),
            attachments: z.array(attachmentMetadataSchema),
            files: z.array(attachmentFileReferenceSchema).default([]),
        });
    })(Submission.Request || (Submission.Request = {}));
    (function (Response) {
        Response.schema = z.object({
            id: emailSubmissionId,
            duplicate: z.boolean(),
        });
    })(Submission.Response || (Submission.Response = {}));
})(Submission || (Submission = {}));
var Attachment;
(function (Attachment) {
    (function (ReserveUpload) {
        (function (Request) {
            Request.schema = z.object({
                attachments: z.array(z.object({
                    filename: z.string().min(1),
                    mimeType: z.string().min(1),
                })),
            });
        })(ReserveUpload.Request || (ReserveUpload.Request = {}));
        (function (Response) {
            Response.schema = z.object({
                attachments: z.array(z.object({
                    filename: z.string(),
                    fileId: fileId.nullable(),
                    uploadUrl: z.string().nullable(),
                })),
            });
        })(ReserveUpload.Response || (ReserveUpload.Response = {}));
    })(Attachment.ReserveUpload || (Attachment.ReserveUpload = {}));
})(Attachment || (Attachment = {}));
var SyncState;
(function (SyncState) {
    (function (Get) {
        (function (Response) {
            Response.schema = z.object({
                lastHistoryId: z.string().nullable(),
                watchExpiration: dateTimeSchema.nullable(),
            });
        })(Get.Response || (Get.Response = {}));
    })(SyncState.Get || (SyncState.Get = {}));
    (function (Put) {
        (function (Request) {
            Request.schema = z.object({
                lastHistoryId: z.string().min(1).optional(),
                watchExpiration: dateTimeSchema.optional(),
            });
        })(Put.Request || (Put.Request = {}));
    })(SyncState.Put || (SyncState.Put = {}));
})(SyncState || (SyncState = {}));

export { Attachment, Submission, SyncState };
